export { default } from './DefaultSearchComponent';
